import { useMemo, useState } from "react";
import { Button, Typography } from "@mui/material";
import { Box } from "@mui/system";
import { useSearchParams } from "react-router-dom";

import { ErrorCard, Header, ManualLoader, Wrapper } from "src/components";
import { useAuth0 } from "@auth0/auth0-react";
import tokens from "src/shared/theme/tokens";
import { readAuthReturnTo } from "src/shared/utilities/authRedirect";

export const Error401ScreenContainer = () => {
  const { loginWithRedirect } = useAuth0();
  const [searchParams] = useSearchParams();
  // Capture once so clearing sessionStorage does not flip the message mid-render.
  const idleLogout = useMemo(() => {
    const fromQuery = searchParams.get("reason") === "idle";
    let fromStorage = false;
    try {
      fromStorage = sessionStorage.getItem("tp_logout_reason") === "idle";
      if (fromStorage) sessionStorage.removeItem("tp_logout_reason");
    } catch {
      // ignore
    }
    return fromQuery || fromStorage;
    // eslint-disable-next-line react-hooks/exhaustive-deps -- intentional one-shot read
  }, []);

  const [isLoader, setIsLoader] = useState(false); // handle login page visibility throgh the components __

  const webAuthnSignIn = async () => {
    setIsLoader(true);

    const returnTo = readAuthReturnTo("/");
    await loginWithRedirect({
      authorizationParams: {
        responseType: "code",
        redirectUri: `${window.location.origin}`,
        mode: "login",
      },
      appState: { returnTo },
    });

    setTimeout(function () {
      setIsLoader(false);
    }, 1200);
  };

  return (
    <Wrapper>
      {isLoader && <ManualLoader />}
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          minHeight: "calc(var(--vh, 1vh) * 100)",
          background: tokens.colors.pageBg,
        }}
      >
        <Header isBackButtonVisible={false} />
        <Box
          sx={{
            flex: 1,
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            paddingX: { xs: 6, sm: 10 },
            paddingBottom: 8,
            textAlign: "center",
          }}
        >
          <ErrorCard>
            <Typography
              variant="h3"
              component={"p"}
              color={tokens.colors.inkSecondary}
              textAlign={"center"}
              marginBottom={6}
            >
              {idleLogout
                ? "You were signed out due to inactivity. Sign in again to continue your application where you left off."
                : "Sorry, you have been logged out! Please log in again."}
            </Typography>
            <Button
              variant="contained"
              color="primary"
              type="button"
              sx={{ width: "100px", marginX: "auto" }}
              onClick={webAuthnSignIn}
            >
              {"Sign In"}
            </Button>
          </ErrorCard>
        </Box>
      </Box>
    </Wrapper>
  );
};
